import * as React from 'react';
import { navigate } from 'router';
import { connect } from 'react-redux';
import { createRouteNodeSelector } from 'redux-router5';

import { parseLocationFilter, locationFilterParams } from '~/apps/shared/services/qsfilter';

import CurrentOrgInjector from '~/apps/shared/containers/app/CurrentOrgInjector';
import LocationHeaderComp from '~/apps/shared/containers/locations/OrgLocationHeader';


const LocationHeader = (props) => {
  const { route: { params } } = props;
  const filter = parseLocationFilter(params);

  return (
    <CurrentOrgInjector
      component={LocationHeaderComp}
      filter={filter}
      onSearch={(q) => {
        filter.q = q;
        navigate('pos.admin.locations', locationFilterParams(filter));
      }}
    />
  );
};

export default connect(createRouteNodeSelector('pos.admin'))(LocationHeader);
